import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import { H7 } from 'UIComponents/elements/headings';
import { hasNewIlsTimeFiltersEnabled, hasRemoveTimezoneForDates } from '../../permissions/gates';
import ConditionWarningBanner from '../ConditionWarningBanner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import Small from 'UIComponents/elements/Small';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TimezoneToggle = ({
  fieldType,
  useUTC,
  onChange,
  getIsUngated,
  isNotUsingTimePoints
}) => {
  if (!hasNewIlsTimeFiltersEnabled(getIsUngated) || isNotUsingTimePoints) {
    return null;
  }
  const showWarningBanner = fieldType === DATE && !useUTC && !hasRemoveTimezoneForDates(getIsUngated) || fieldType === DATE_TIME && useUTC;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.TimezoneToggle.label"
      }),
      children: /*#__PURE__*/_jsxs(UIToggleGroup, {
        name: "timezone-toggle",
        children: [/*#__PURE__*/_jsx(UIRadioInput, {
          checked: !useUTC,
          inline: true,
          onChange: () => onChange(false),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.TimezoneToggle.portal"
          })
        }), /*#__PURE__*/_jsx(UIRadioInput, {
          checked: useUTC,
          inline: true,
          onChange: () => onChange(true),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.TimezoneToggle.utc"
          })
        })]
      })
    }), showWarningBanner && /*#__PURE__*/_jsx(ConditionWarningBanner, {
      className: "m-all-0 m-bottom-2",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(H7, {
          className: "m-top-1 m-bottom-0",
          children: fieldType === DATE ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.TimezoneToggle.portalTimezoneUsageWarning.title"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.TimezoneToggle.utcUsageWarning.title"
          })
        }), /*#__PURE__*/_jsx(Small, {
          children: fieldType === DATE ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.TimezoneToggle.portalTimezoneUsageWarning.description"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.TimezoneToggle.utcUsageWarning.description"
          })
        })]
      })
    })]
  });
};
TimezoneToggle.propTypes = {
  getIsUngated: PropTypes.func.isRequired,
  isNotUsingTimePoints: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  useUTC: PropTypes.bool.isRequired
};
export default TimezoneToggle;